import React, { useContext } from "react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ApplicantProfileTabs from "../Contents/ApplicantProfile/ApplicantProfileTabs";
import { Button, IconButton, TextField } from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { useState } from "react";
import Badge from '@mui/material/Badge';
import { ContextData } from "../../../context/Context";
import { Getrequest, Putrequest } from "../../../context/AxiosRequest";
import { toast } from "react-toastify";
import VerificationStatusListDialogue from "./verification/VerificationStatusListDialogue";
import SoundAlert from "../../../routes/SoundAlert";

function Verification({type,name,params,applincntNumbr}) {


  const [searchText, setSearchText] = useState("");
  const {accesstoken,GlobalLoader,setGlobalLoader,Allow,UserTokens} = useContext(ContextData)
  const [ApplicantData,setApplicantData] = React.useState([])
  const [GetToken,setGetToken] = React.useState()
  const [Reload,setReload] = React.useState(false)
  
  
      const GetApplicant = (user_token)=>{
  
       setGetToken(user_token)

      }
  
      React.useEffect(()=>{
  
                    async function FetchData() {
                         const response = await Getrequest(`auth/get_applicantBio_for_qualification_type/${params===undefined?"verify":params==="returned_by_approver"?"return":params}/${params==="returned_by_approver"?"approval":"verification"}`,accesstoken)
                          setApplicantData(response)
                        }
    
                  FetchData()  
      },[GlobalLoader,Reload])

      

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };




  const HandleVerify = async (user_token,type) => {


 
    const data = {
      user_token,
      type,
      verifier_token: UserTokens
    };

    const response = await Putrequest( `auth/handle_verify_done_return`,data,accesstoken);
    
        if(response.status){

           toast.success(response.textStatus);
           setGlobalLoader(!GlobalLoader)
           SoundAlert("success")

        }else{

          toast.warn(response.textStatus);
          SoundAlert("error");
        }

  }

  const [DataValue, setDataValue] = useState("loan");
  const handleChange = (event) => {
    setDataValue(event.target.value);
  };


  
  return (
    <div className="h-[92vh] p-6 overflow-x-hidden">

      <h1 className="font-bold text-2xl"> {name !== undefined ? `${name} (${applincntNumbr})` : "Verification"} </h1>
 

          {
            type !== "VerificationStatusListDialogue" &&
        <div className="flex justify-center items-center mb-4 mt-4 gap-4">
          <p className="whitespace-nowrap">Select Application Type:</p>
            <select
            onChange={handleChange}
            value={DataValue}
            className="w-full p-2 rounded-md bg-[#030323e6] text-white font-bold"
            >
       {/*  <option value="scholarship">Scholarship Applications</option> */}
        <option value="loan">Loan Applications</option>
      </select>
        </div>
          }
          {
          type !== "VerificationStatusListDialogue" &&
          <div className="flex flex-row">
          <VerificationStatusListDialogue
            type="return"
            Bgcolor=""
            name="Return Applications"
            
            
          />
          <VerificationStatusListDialogue
            type="returned_by_approver"
            Bgcolor="green"
            name="Returned Applications from Approval"
          />

          </div>
          }
          
      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
            <IconButton>
              <SearchIcon />
            </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <div className=" d-flex items-start h-[100%]  ">
        <div
          style={{ height: "100%" }}
          className="verification-aside w-1/3 bg-slate-100 overflow-auto border-r-2 border-black border-solid"
        > 
          
           {
            params === "returned_by_approver" &&
            <ul className="ver-aside-ul mb-28">
            {ApplicantData.length > 0  && ApplicantData.map((item, index) => (
              <li className={`flex justify-between whitespace-nowrap  items-center ${item?.user_token === GetToken && "bg-blue-700 text-white"}`} onClick={()=> GetApplicant(item?.user_token)}  key={index}>
                <span>
                <span className="pl-1 pr-1">{index + 1}.</span>
                <AccountCircleIcon /> {`${item.fname}`}
                </span>
                 {
                  ( item.verify_status === "returned_by_approver")  && 
                <span className="flex pr-2">
                  <Button onClick={()=>HandleVerify(item.user_token,"pending")} variant="contained" sx={{background:"darkred",marginRight:"4px"}} disabled={item.user_token !== GetToken }>Return</Button>
                    <Button onClick={()=>HandleVerify(item.user_token,"verified")} variant="contained" disabled={item.user_token !== GetToken }>Verify</Button>
                </span>
                 }
               
              </li> 
            ))}
           </ul> 
        
           }


            {
            params === "return" &&

             <ul className="ver-aside-ul mb-28">
            {ApplicantData.length > 0 && ApplicantData.map((item, index) => (
              <li className={`flex justify-between whitespace-nowrap  items-center ${item.user_token === GetToken && "bg-blue-700 text-white"}`} onClick={()=> GetApplicant(item.user_token)}  key={index}>
                <span>
                <span className="pl-1 pr-1">{index + 1}.</span>
                  {
                  //  item.unread_status === "reread" &&
                     <Badge color="error" badgeContent={"returned"} anchorOrigin={{
                   vertical: 'top',
                   horizontal: 'left',
                  }} overlap="circular">
                  <AccountCircleIcon /> {`${item.fname}`}
                  </Badge>
                  }

                 {/*   {
                   item.unread_status === "read" &&
                    <span>   <AccountCircleIcon /> {`${item.fname}`}</span>
                   } */}
                 
                </span>
                
                <span className="flex pr-2">
                  <Button onClick={()=>HandleVerify(item.user_token,"disqualified")} variant="contained" sx={{background:"darkred",marginRight:"4px"}} disabled={item.user_token !== GetToken }>Disqualify</Button>
                   <Button onClick={()=>HandleVerify(item.user_token,"pending")} variant="contained" sx={{background:"red",marginRight:"4px"}} disabled={item.user_token !== GetToken }>Return</Button>
                  <Button onClick={()=>HandleVerify(item.user_token,"verified")} variant="contained" disabled={item.user_token !== GetToken }>Verify</Button>
                </span>
                
               
              </li> 
            ))}
          </ul> 
            }

            

            {
            params === undefined &&
             <ul className="ver-aside-ul mb-28">
            {ApplicantData.length > 0 && ApplicantData.map((item, index) => (
               <li className={`flex justify-between whitespace-nowrap  items-center ${item.user_token === GetToken && "bg-blue-700 text-white"}`} onClick={()=> GetApplicant(item.user_token)}  key={index}>
              
                <span>
                <span className="pl-1 pr-1">{index + 1}.</span>
            
                <AccountCircleIcon /> {`${item.fname}`}
                </span>
                 
                 {
                  ( item.verify_status === "Not Verified")  && 
                <span className="flex pr-2">
                  <Button onClick={()=>HandleVerify(item.user_token,"pending")} variant="contained" sx={{background:"darkred",marginRight:"4px"}} disabled={item.user_token !== GetToken }>Return</Button>
                  <Button onClick={()=>HandleVerify(item.user_token,"verified")} variant="contained" disabled={item.user_token !== GetToken }>Verify</Button>
                </span>
                 }
               
            
            
                </li> 
            ))}
          </ul> 
            }


        </div>

        <div style={{ height: "100%", width:"100%" }} className="overflow-auto mb-40">
          <ApplicantProfileTabs Reload={Reload} setReload={setReload} sty="sty" applicationType={DataValue} usertoken={GetToken} from="verification" />
        </div>
      </div>
    </div>
  );
}

export default Verification;
